import React, { useEffect, useState } from "react";
import CommonTable from "../../components/commonComponents/Table/CommonTable";
import Heading from "../../components/commonComponents/Heading/Heading";
import styles from "../Inventory/Inventory.module.css";
import { RiFileExcel2Fill } from "react-icons/ri";
import { FaFileCsv, FaFilePdf } from "react-icons/fa";
import {
  Grid,
  Box,
  IconButton,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox,
  ListItemText,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import {
  Edit,
  Delete,
  ContentCopy as ContentCopyIcon,
} from "@mui/icons-material";
import {
  generateCSV,
  generateExcel,
  generatePDF,
  handleCsvGeneration,
} from "../../utils/exportUtils";
import { updateOrderData, fetchAllCustomerData } from "./Utility";
import axios from "axios";
import { green } from "@mui/material/colors";
import moment from "moment";
import {
  accountEmail,
  isSuperAdmin,
  userPermissions,
} from "../customerManagement/utility/authUtils";
import { number } from "framer-motion";
import { Spinner } from "../../components/commonComponents/Spinner/Spinner";
import { BASE_URL } from "../../config";

const tableCss = {
  moduleHeight: "37.9rem",
  cellPadding: "12px 16px",
  tableWidth: "100%!important",
};

const permissions = userPermissions()?.order?.orders?.edit;

const buttonArray = [
  {
    name: null,
    key: "excel",
    icon: <RiFileExcel2Fill />,
  },
  {
    name: null,
    key: "csv",
    icon: <FaFileCsv />,
  },
  {
    name: null,
    key: "pdf",
    icon: <FaFilePdf />,
  },
  {
    name: "Create Order",
    key: "add_customer",
    icon: <AddIcon />,
    visible: permissions,
  },
];

const CreateOrder = () => {
  const [columns, setColumns] = useState([
    {
      name: "Sr. No",
      selected: true,
      key: "serial",
      showExcel: true,
      showTable: true,
      showPDF: true,
      showcheck: false,
    },
    {
      name: "Account Name",
      key: "accountName",
      showExcel: true,
      showTable: true,
      showPDF: true,
      selected: true,
    },

    {
      name: "Order Number",
      key: "orderNumber",
      showExcel: true,
      showTable: true,
      showPDF: true,
      selected: true,
      render: (rowData) =>
        rowData.orderStatus === "Draft" ? "" : rowData.orderNumber,
    },
    {
      name: "Order Date",
      key: "orderDate",
      showExcel: true,
      showTable: true,
      showPDF: true,
      selected: true,
    },
    {
      name: "Order Status",
      key: "orderStatus",
      showExcel: true,
      showTable: true,
      showPDF: true,
      selected: true,
    },
    {
      name: "Order Description",
      key: "orderDescription",
      showExcel: true,
      showTable: true,
      showPDF: true,
      selected: true,
    },
    {
      name: "Sim Type",
      key: "simType",
      showExcel: true,
      showTable: true,
      showPDF: true,
      selected: true,
    },
    {
      name: "No. of Sims",
      key: "numberOfSims",
      showExcel: true,
      showTable: true,
      showPDF: true,
      selected: true,
    },
    {
      name: "Rejection Reason",
      key: "rejectionReason",
      selected: true,
      showExcel: true,
      showTable: true,
      showPDF: true,
    },
    {
      name: "Download Invoice",
      key: "downloadInvoice",
      selected: true,
      showExcel: false,
      showTable: true,
      showPDF: false,
      render: (rowData) => rowData.downloadInvoice,
    },
    {
      name: "Action",
      key: "action",
      selected: true,
      showExcel: true,
      showTable: true,
      showPDF: true,
    },
  ]);

  const [customerList, setCustomerList] = useState([]);
  const [csvData, setCsvData] = useState(null);
  const [totalRows, setTotalRows] = useState(0);
  const [createDialogOpen, setCreateDialogOpen] = useState(false);
  const [editingOrder, setEditingOrder] = useState(null);
  const [submittedorderNumber, setSubmittedorderNumber] = useState(null);
  const [filters, setFilters] = useState({
    pageNo: 0,
    pageSize: 10,
    search: "",
  });
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [allCustomerData, setAllCustomerData] = useState([]);

  const companyId = localStorage.getItem("userId");

  const getDownloadIcon = (rowData) => {
    return (
      <IconButton
        size="small"
        onClick={() => handleDownloadInvoice(rowData.orderNumber)}
        title="Download Invoice"
      >
        <FaFilePdf style={{ color: "red" }} />
      </IconButton>
    );
  };
  const getAuthToken = () => localStorage.getItem("authToken");
  const getCompanyId = () => localStorage.getItem("userId");
  const handleDownloadInvoice = async (orderNumber) => {
    try {
      const token = getAuthToken();
      const companyId = getCompanyId();
      const response = await fetch(
        `${BASE_URL}api/order/download/${orderNumber}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = `Invoice-${orderNumber}.pdf`;
      document.body.appendChild(a);
      a.click();

      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error downloading invoice:", error);
      alert("Failed to download invoice. Please try again later.");
    }
  };
  const fetchCustomerData = async () => {
    const data = await fetchAllCustomerData();
    const bodyData = Array.isArray(data?.body) ? data.body : [];

    const dataWithSerialAndActions = bodyData.map((item, index) => ({
      ...item,
      orderDate: item.orderDate ? item.orderDate.split("T")[0] : "",
      serial: index + 1,
      action: getActionIcons(item, index),
      downloadInvoice: getDownloadIcon(item),
    }));

    setAllCustomerData(dataWithSerialAndActions);
  };
  function getActionIcons(rowData, index) {
    const isDraft = rowData.orderStatus === "Draft";
    const canEdit = isSuperAdmin();
    console.log(
      "Can Edit:",
      canEdit,
      "Is Draft:",
      isDraft,
      "Company ID:",
      companyId
    );

    return (
      <Box sx={{ display: "flex", gap: 1 }}>
        <IconButton
          size="small"
          onClick={() => canEdit && handleActionClick("edit", rowData, index)}
          title="Edit Order"
          disabled={!canEdit}
        >
          <Edit
            fontSize="small"
            sx={{ color: canEdit ? "blue" : "grey.400" }}
          />
        </IconButton>
        <IconButton
          size="small"
          onClick={async () => {
            if (canEdit) {
              await updateOrderData(rowData, "delete");
              await fetchCustomerData();
            }
          }}
          title="Delete Order"
          disabled={!canEdit}
        >
          <Delete
            fontSize="small"
            sx={{ color: canEdit ? "error.main" : "grey.400" }}
          />
        </IconButton>
      </Box>
    );
  }
  const handleSearchChange = (newSearchTerm) => {
    setFilters((prev) => ({
      ...prev,
      search: newSearchTerm,
      pageNo: 0,
    }));
  };
  const handlePageChange = (_, newPage) => {
    setFilters((prev) => ({ ...prev, pageNo: newPage }));
  };

  const handleRowsPerPageChange = (event) => {
    setFilters((prev) => ({
      ...prev,
      pageNo: 0,
      pageSize: parseInt(event.target.value, 10),
    }));
  };

  const handleActionClick = (action, rowData, index) => {
    const isOrderRejected = rowData.orderStatus === "Rejected";
    const isOrderCompleted = rowData.orderStatus === "Completed";

    switch (action) {
      case "edit":
        if (isOrderCompleted) {
          alert("Order is completed and cannot be modified.");

          return;
        } else if (isOrderRejected) {
          alert("Order is rejected and cannot be modified.");
          return;
        } else {
          setEditingOrder({ ...rowData, originalIndex: index });
          setCreateDialogOpen(true);
        }

        break;
      case "delete":
        break;
      default:
        console.log("Unknown action:", action);
    }
  };

  const handleButtonAction = (action) => {
    switch (action) {
      case "add_customer":
        setEditingOrder(null);
        setCreateDialogOpen(true);
        break;
      case "excel":
        generateExcel(customerList, columns, "customer_data.xlsx");
        break;
      case "pdf":
        generatePDF(customerList, columns, "customer_data.pdf");
        break;
      case "csv":
        const csvExportData = handleCsvGeneration(customerList, columns);
        setCsvData(csvExportData);
        break;
      default:
        console.log("Unknown action:", action);
    }
  };
  const CreateOrderModal = ({
    open,
    onClose,
    editingOrder,
    allCustomerData,
    fetchCustomerData,
    setSubmittedorderNumber,
  }) => {
    console.log(editingOrder,"hanu")
    const initialFormData = editingOrder
 
      ? {
          ...editingOrder,
          orderDate: editingOrder.orderDate
  ? editingOrder.orderDate.split("T")[0]
  : "",
  primaryProfile: editingOrder.primaryProfile ? editingOrder.primaryProfile :"",
  secondaryProfile:editingOrder.secondaryProfile? editingOrder.secondaryProfile:""
        }
      : {
          accountName: "",
          accountType: "",
          orderNumber: "",
          orderDate: "",
          orderStatus: "Draft",
          orderDescription: "",
          simType: "",
          numberOfSims: "",
          cost: 10,
        };
        

    const [formData, setFormData] = useState(initialFormData);
    const [formErrors, setFormErrors] = useState({});
    const [accountNameOptions, setAccountNameOptions] = useState([]);

    // 👇 New states for rejection reason
    const [showRejectReason, setShowRejectReason] = useState(false);
    const [rejectionReason, setRejectionReason] = useState("");
    const [rejectError, setRejectError] = useState("");
    // Profile selection states
    const [primaryProfile, setPrimaryProfile] = useState("");
    const [secondaryProfile, setSecondaryProfile] = useState("");
    const [plasticProfile, setPlasticProfile] = useState("");
    const [cost, setCost] = useState("");
    const profileOptions = ["Airtel", "BSNL", "JIO", "VI"];
    useEffect(() => {
      if (editingOrder) {
        setPrimaryProfile(editingOrder.primaryProfile || "");
        setSecondaryProfile(editingOrder.secondaryProfile || "");
        setPlasticProfile(editingOrder.plasticProfile || "");
      } else {
        setPrimaryProfile("");
        setSecondaryProfile("");
        setPlasticProfile("");
      }
    }, [editingOrder]);
    const isOrderAccepted =
      editingOrder && editingOrder.orderStatus === "Accepted";
    const isOrderRejected =
      editingOrder && editingOrder.orderStatus === "Rejected";
    const isOrderCompleted =
      editingOrder && editingOrder.orderStatus === "Completed";

    useEffect(() => {
      if (open) {
        if (editingOrder) {
          setFormData({
            ...editingOrder,
           orderDate: editingOrder.orderDate
  ? editingOrder.orderDate.split("T")[0]
  : "",
  primaryProfile: editingOrder.primaryProfile ? editingOrder.primaryProfile :"",
  secondaryProfile:editingOrder.secondaryProfile? editingOrder.secondaryProfile:""
          });
        } else {
          setFormData({
            accountName: "",
            accountType: "",
            orderNumber: "",
            orderDate: moment().format("YYYY-MM-DD"),
            orderStatus: "Draft",
            orderDescription: "",
            simType: "",
            numberOfSims: "",
          });
        }
        setFormErrors({});
        setShowRejectReason(false);
        setRejectionReason("");
        setRejectError("");
        fetchAccountNames();
      }
    }, [open, editingOrder]);

    const fetchAccountNames = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const response = await fetch(`${BASE_URL}api/v4/account/all`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            accountId: companyId,
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();

        if (result.success && Array.isArray(result.data)) {
          setAccountNameOptions(result.data);
          if (!editingOrder && result.data.length > 0) {
            const firstAcc = result.data[0];
            setFormData((prev) => ({
              ...prev,
              accountId: firstAcc.id,
              accountName: firstAcc.companyName,
              accountType: firstAcc.accountType,
            }));
          } else if (editingOrder && editingOrder.accountName) {
            const matchingAccount = result.data.find(
              (acc) => acc.companyName === editingOrder.accountName
            );
            if (matchingAccount) {
              setFormData((prev) => ({
                ...prev,
                accountId: matchingAccount.id,
              }));
            }
          }
        }
      } catch (error) {
        console.error("Error fetching account names:", error);
      }
    };

    const simOption = ["eSIM", "Plastic SIM - Mini", "Plastic SIM - Micro"];

    const getErrorStyles = (hasError) => ({
      transition: "all 0.3s ease-in-out",
      boxShadow: hasError ? "0 0 5px 1px rgba(244, 67, 54, 0.6)" : "none",
      backgroundColor: hasError ? "#fff5f5" : "#fff",
    });

    const errorTextStyle = {
      color: "#f44336",
      fontSize: "0.75rem",
      marginTop: "4px",
      marginLeft: "14px",
      fontWeight: 500,
    };
    const handleChange = (event) => {
      const { name, value } = event.target;

      if (name === "numberOfSims") {
        if (/^\d*$/.test(value)) {
          setFormData((prev) => ({ ...prev, [name]: value }));
          setFormErrors((prev) => ({ ...prev, [name]: "" }));
        } else {
          setFormErrors((prev) => ({
            ...prev,
            [name]: "Enter valid digits only",
          }));
        }
      } else {
        setFormData((prev) => ({ ...prev, [name]: value }));
        setFormErrors((prev) => ({ ...prev, [name]: "" }));
      }
    };
    const handleSave = async () => {
      const isEditing = !!editingOrder;
      const dateInMilliseconds = formData.orderDate
        ? new Date(formData.orderDate).getTime()
        : "";
      const numberOfSimsAsNumber = parseInt(formData.numberOfSims, 10);

      const dataToSend = {
        ...formData,
        orderStatus: "Draft",
        orderDate: dateInMilliseconds,
        numberOfSims: numberOfSimsAsNumber,
        orderNumber: isEditing ? formData.orderNumber : "",
        accountId: companyId,
        email: accountEmail(),
        rejectionReason: "",
      };

      if (isEditing) {
        dataToSend.orderId = editingOrder.orderId;
      }

      await updateOrderData(dataToSend, isEditing ? "update" : "add");
      fetchCustomerData();
      onClose();
    };

    const handleAccept = async () => {
      const isEditing = !!editingOrder;
      const dateInMilliseconds = formData.orderDate
        ? new Date(formData.orderDate).getTime()
        : "";
      const numberOfSimsAsNumber = parseInt(formData.numberOfSims, 10);

      const dataToSend = {
        ...formData,
        orderStatus: "Accepted",
        orderDate: dateInMilliseconds,
        numberOfSims: numberOfSimsAsNumber,
        accountId: companyId,
        rejectionReason: "",
        email: accountEmail(),
      };

      if (isEditing) {
        dataToSend.orderId = editingOrder.orderId;
      }

      await updateOrderData(dataToSend, isEditing ? "update" : "add");
      fetchCustomerData();
      onClose();
    };

    const handleReject = async () => {
      if (!showRejectReason) {
        setShowRejectReason(true);
        return;
      }

      if (!rejectionReason.trim()) {
        setRejectError("Rejection reason is required");
        return;
      }

      const isEditing = !!editingOrder;
      const dateInMilliseconds = formData.orderDate
        ? new Date(formData.orderDate).getTime()
        : "";
      const numberOfSimsAsNumber = parseInt(formData.numberOfSims, 10);

      const dataToSend = {
        ...formData,
        orderStatus: "Rejected",
        orderDate: dateInMilliseconds,
        numberOfSims: numberOfSimsAsNumber,
        accountId: companyId,
        rejectionReason: rejectionReason.trim(),
        email: accountEmail(),
      };

      if (isEditing) {
        dataToSend.orderId = editingOrder.orderId;
      }

      await updateOrderData(dataToSend, isEditing ? "update" : "add");
      fetchCustomerData();
      setRejectionReason("");
      setShowRejectReason(false);
      onClose();
    };

    const handleComplete = async () => {
      const isEditing = !!editingOrder;
      const dateInMilliseconds = formData.orderDate
        ? new Date(formData.orderDate).getTime()
        : "";
      const numberOfSimsAsNumber = parseInt(formData.numberOfSims, 10);

      const dataToSend = {
        ...formData,
        orderStatus: "Completed",
        orderDate: dateInMilliseconds,
        numberOfSims: numberOfSimsAsNumber,
        accountId: companyId,
        email: accountEmail(),
        rejectionReason: "",
      };

      if (isEditing) {
        dataToSend.orderId = editingOrder.orderId;
      }

      await updateOrderData(dataToSend, isEditing ? "update" : "add");
      fetchCustomerData();
      onClose();
    };
    const handleSubmit = async () => {
      debugger;
      const errors = {};

      if (!formData.accountType) {
        errors.accountType = "Account Type is required";
      } else if (formData.accountType.toLowerCase() === "test") {
        alert(
          "Order cannot be created with Account Type 'test'. Please select a different account."
        );
        errors.accountType = "Order cannot be created with Account Type 'test'";
      }
      if (!formData.simType) errors.simType = "Sim Type is required";
      if (formData.simType === "eSIM") {
        if (!primaryProfile) {
          errors.primaryProfile = "Primary Profile is required for eSIM";
        }
      }
      if (
        formData.simType === "Plastic SIM - Mini" ||
        formData.simType === "Plastic SIM - Micro"
      ) {
        if (!plasticProfile) {
          errors.plasticProfile = "Profile is required for Plastic SIM";
        }
      }

      if (!formData.orderDate) {
        errors.orderDate = "Order Date is required";
      } else {
        if (!editingOrder) {
          const today = new Date();
          const selectedDate = new Date(formData.orderDate);
          today.setHours(0, 0, 0, 0);
          selectedDate.setHours(0, 0, 0, 0);
          if (selectedDate < today) {
            errors.orderDate = "Order Date cannot be in the past";
          }
        }
      }

      if (formData.numberOfSims) {
        if (!/^\d+$/.test(formData.numberOfSims)) {
          errors.numberOfSims = "Enter valid digits only";
        } else if (parseInt(formData.numberOfSims, 10) === 0) {
          errors.numberOfSims = "Number of SIMs cannot be 0";
        } else if (parseInt(formData.numberOfSims, 10) > 1000000) {
          errors.numberOfSims = "Enter valid value (must be ≤ 1000000)";
        }
      }

      setFormErrors(errors);

      if (Object.keys(errors).length > 0) {
        return;
      }
      const isEditing = !!editingOrder;
      let orderNumberToUse = formData.orderNumber;

      if (!isEditing || !formData.orderNumber || formData.orderNumber === "") {
        const lastorderNumber =
          allCustomerData.length > 0
            ? Math.max(
                ...allCustomerData.map(
                  (item) => parseInt(item.orderNumber) || 0
                )
              )
            : 1000;
      }

      const dateInMilliseconds = new Date(formData.orderDate).getTime();
      const numberOfSimsAsNumber = parseInt(formData.numberOfSims, 10);

      const dataToSend = {
        ...formData,
        // orderNumber: orderNumberToUse,
        orderStatus: "Submitted",
        orderDate: dateInMilliseconds,
        numberOfSims: numberOfSimsAsNumber,
        accountId: companyId,
        rejectionReason: "",
        email: accountEmail(),
        cost: formData.cost,
      };
      if (formData.simType === "eSIM") {
        dataToSend.primaryProfile = primaryProfile;
        dataToSend.secondaryProfile = secondaryProfile;
      } else if (
        formData.simType === "Plastic SIM - Mini" ||
        formData.simType === "Plastic SIM - Micro"
      ) {
        dataToSend.plasticProfile = plasticProfile;
      }

      if (isEditing) {
        dataToSend.orderId = editingOrder.orderId;
      }

      try {
        setLoading(true);
        const res = await updateOrderData(
          dataToSend,
          isEditing ? "update" : "add"
        );
        let orderNumber = res?.body?.orderNumber;
        console.log(orderNumber, "hjkl");
        if (orderNumber) {
          setSubmittedorderNumber(orderNumber);
        }
        fetchCustomerData();
        onClose();
      } catch (error) {
        console.error("Order submission failed:", error);
      } finally {
        setLoading(false);
      }
    };

    return (
      <>
        {loading ? (
          <Spinner />
        ) : (
          <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
            <DialogTitle>
              {editingOrder ? "Edit Order" : "Create Order"}
            </DialogTitle>
            <DialogContent>
              <Grid container spacing={3} sx={{ mt: 1 }}>
                {/* Account Name */}
                <Grid item xs={12} md={6}>
                  <FormControl
                    fullWidth
                    variant="outlined"
                    required
                    sx={getErrorStyles(formErrors.accountName)}
                  >
                    <InputLabel id="accountName-label">Account Name</InputLabel>
                    <Select
                      labelId="accountName-label"
                      label="Account Name"
                      name="accountId"
                      disabled={editingOrder}
                      value={formData.accountId || ""}
                      onChange={(e) => {
                        const selected = accountNameOptions.find(
                          (acc) => acc.id === e.target.value
                        );
                        if (selected) {
                          setFormData((prev) => ({
                            ...prev,
                            accountId: selected.id,
                            accountName: selected.companyName,
                            accountType: selected.accountType,
                          }));
                        }
                      }}
                      error={!!formErrors.accountName}
                      renderValue={(selectedId) => {
                        const selected = accountNameOptions.find(
                          (acc) => acc.id === selectedId
                        );
                        if (selected) {
                          return selected.companyName;
                        } else if (editingOrder && editingOrder.accountName) {
                          return editingOrder.accountName;
                        } else {
                          return "Select Account";
                        }
                      }}
                    >
                      {accountNameOptions.map((acc) => (
                        <MenuItem key={acc.id} value={acc.id}>
                          {acc.companyName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  {formErrors.accountName && (
                    <div style={errorTextStyle}>{formErrors.accountName}</div>
                  )}
                </Grid>
                {formData.orderNumber && formData.orderStatus !== "Draft" && (
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Order Number"
                      name="orderNumber"
                      value={formData.orderNumber}
                      variant="outlined"
                      required
                      disabled
                    />
                  </Grid>
                )}

                {/* Order Date */}
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Order Date"
                    name="orderDate"
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    value={formData.orderDate}
                    onChange={handleChange}
                    variant="outlined"
                    required
                    disabled
                    error={!!formErrors.orderDate}
                    sx={getErrorStyles(formErrors.orderDate)}
                  />
                  {formErrors.orderDate && (
                    <div style={errorTextStyle}>{formErrors.orderDate}</div>
                  )}
                </Grid>

                {/* Sim Type */}
                <Grid item xs={12} md={6}>
                  <FormControl
                    fullWidth
                    variant="outlined"
                    required
                    sx={getErrorStyles(formErrors.simType)}
                  >
                    <InputLabel id="simType-label">Sim Type</InputLabel>
                    <Select
                      labelId="simType-label"
                      label="Sim Type"
                      name="simType"
                      disabled={editingOrder}
                      value={formData.simType}
                      onChange={handleChange}
                      error={!!formErrors.simType}
                    >
                      {simOption.map((type) => (
                        <MenuItem key={type} value={type}>
                          {type}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  {formErrors.simType && (
                    <div style={errorTextStyle}>{formErrors.simType}</div>
                  )}
                </Grid>
                {formData.simType === "eSIM" && (
                  <Grid item xs={12} md={12}>
                    <Box
                      sx={{
                        p: 2,
                        border: "1px solid #e0e0e0",
                        borderRadius: 1,
                        mb: 2,
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        sx={{ mb: 2, fontWeight: 600, color: "#1976d2" }}
                      >
                        eSIM Profile Configuration
                      </Typography>

                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                          <FormControl
                            fullWidth
                            variant="outlined"
                            required
                            sx={getErrorStyles(formErrors.primaryProfile)}
                          >
                            <InputLabel id="primary-profile-label">
                              Primary Profile
                            </InputLabel>
                            <Select
                              labelId="primary-profile-label"
                              label="Primary Profile"
                              value={primaryProfile}
                              onChange={(e) =>
                                setPrimaryProfile(e.target.value)
                              }
                              disabled={editingOrder}
                              error={!!formErrors.primaryProfile}
                            >
                              {profileOptions.map((option) => (
                                <MenuItem key={option} value={option}>
                                  {option}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          {formErrors.primaryProfile && (
                            <div style={errorTextStyle}>
                              {formErrors.primaryProfile}
                            </div>
                          )}
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <FormControl fullWidth variant="outlined">
                            <InputLabel id="secondary-profile-label">
                              Secondary Profile (Optional)
                            </InputLabel>
                            <Select
                              labelId="secondary-profile-label"
                              label="Secondary Profile (Optional)"
                              value={secondaryProfile}
                              onChange={(e) =>
                                setSecondaryProfile(e.target.value)
                              }
                              disabled={editingOrder}
                            >
                              <MenuItem value="">
                                <em>None</em>
                              </MenuItem>
                              {profileOptions
                                .filter(
                                  (option) =>
                                    option !== primaryProfile ||
                                    option === secondaryProfile
                                )
                                .map((option) => (
                                  <MenuItem key={option} value={option}>
                                    {option}
                                  </MenuItem>
                                ))}
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>
                    </Box>
                  </Grid>
                )}

                {(formData.simType === "Plastic SIM - Mini" ||
                  formData.simType === "Plastic SIM - Micro") && (
                  <Grid item xs={12} md={12}>
                    <Box
                      sx={{
                        p: 2,
                        border: "1px solid #e0e0e0",
                        borderRadius: 1,
                        mb: 2,
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        sx={{ mb: 2, fontWeight: 600, color: "#1976d2" }}
                      >
                        Plastic SIM Profile Configuration
                      </Typography>

                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                          <FormControl
                            fullWidth
                            variant="outlined"
                            required
                            sx={getErrorStyles(formErrors.plasticProfile)}
                          >
                            <InputLabel id="plastic-profile-label">
                              Profile
                            </InputLabel>
                            <Select
                              labelId="plastic-profile-label"
                              label="Profile"
                              value={plasticProfile}
                              onChange={(e) =>
                                setPlasticProfile(e.target.value)
                              }
                              disabled={editingOrder}
                              error={!!formErrors.plasticProfile}
                            >
                              {profileOptions.map((option) => (
                                <MenuItem key={option} value={option}>
                                  {option}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          {formErrors.plasticProfile && (
                            <div style={errorTextStyle}>
                              {formErrors.plasticProfile}
                            </div>
                          )}
                        </Grid>
                      </Grid>
                    </Box>
                  </Grid>
                )}
                {/* Order Description */}
                <Grid item xs={12} md={6}>
                  <FormControl
                    fullWidth
                    variant="outlined"
                    disabled={editingOrder}
                  >
                    <InputLabel id="order-description-label">
                      Order Description
                    </InputLabel>
                    <Select
                      labelId="order-description-label"
                      name="orderDescription"
                      value={formData.orderDescription}
                      onChange={handleChange}
                      label="Order Description"
                    >
                      <MenuItem value="Standard Order">
                        Standard Order – Regular processing
                      </MenuItem>
                      <MenuItem value="Priority Order">
                        Priority Order – Fast-track processing
                      </MenuItem>
                      <MenuItem value="Custom Order">
                        Custom Order – Special handling required
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Number of SIMs"
                    name="numberOfSims"
                    value={formData.numberOfSims}
                    disabled={editingOrder}
                    onChange={(e) => {
                      let value = e.target.value;
                      value = value.replace(/[^0-9]/g, "");
                      value = value.replace(/^0+/, "");
                      setFormData({
                        ...formData,
                        numberOfSims: value,
                      });
                    }}
                    variant="outlined"
                    error={!!formErrors.numberOfSims}
                    sx={getErrorStyles(formErrors.numberOfSims)}
                    helperText={formErrors.numberOfSims || ""}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Price"
                    name="cost"
                    type="number"
                    value={formData.cost}
                    onChange={handleChange}
                    variant="outlined"
                    required
                    disabled
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                {showRejectReason && (
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Rejection Reason"
                      value={rejectionReason}
                      onChange={(e) => {
                        setRejectionReason(e.target.value);
                        setRejectError("");
                      }}
                      variant="outlined"
                      required
                      error={!!rejectError}
                      helperText={rejectError}
                    />
                  </Grid>
                )}
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button onClick={onClose} color="secondary" variant="outlined">
                Cancel
              </Button>
              {isOrderAccepted && (
                <>
                  <Button
                    onClick={handleComplete}
                    color="success"
                    variant="contained"
                  >
                    Complete
                  </Button>
                  {isSuperAdmin() && (
                    <Button
                      onClick={handleReject}
                      color="error"
                      variant="contained"
                    >
                      {showRejectReason ? "Confirm Reject" : "Reject"}
                    </Button>
                  )}
                </>
              )}
              {!isOrderRejected && !isOrderCompleted && !isOrderAccepted && (
                <>
                  {editingOrder && isSuperAdmin() ? (
                    <>
                      <Button
                        onClick={handleAccept}
                        color="success"
                        variant="contained"
                      >
                        Accept
                      </Button>
                      <Button
                        onClick={handleReject}
                        color="error"
                        variant="contained"
                      >
                        {showRejectReason ? "Confirm Reject" : "Reject"}
                      </Button>
                    </>
                  ) : null}

                  <Button
                    onClick={handleSave}
                    color="primary"
                    variant="outlined"
                  >
                    Save
                  </Button>
                  <Button
                    onClick={handleSubmit}
                    color="primary"
                    variant="contained"
                  >
                    Submit
                  </Button>
                </>
              )}
            </DialogActions>
          </Dialog>
        )}
      </>
    );
  };

  const SubmittedOrderConfirmationModal = ({ open, orderNumber, onClose }) => {
    const handleCopy = () => {
      navigator.clipboard.writeText(orderNumber);
      alert("Order Number copied to clipboard!");
    };

    const handleDownloadInvoice = async () => {
      try {
        const token = getAuthToken();
        const companyId = getCompanyId();
        const response = await fetch(
          `${BASE_URL}api/order/download/${orderNumber}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error(`Error: ${response.status}`);
        }
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `Invoice-${orderNumber}.pdf`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      } catch (error) {
        console.error("Error downloading invoice:", error);
        alert("Failed to download invoice. Please try again later.");
      }
    };

    return (
      <Dialog
        open={open}
        onClose={onClose}
        PaperProps={{
          sx: {
            borderRadius: 3,
            background: "linear-gradient(135deg, #ffffff 0%, #f5f5f5 100%)",
            color: "#333333",
            minWidth: 400,
            boxShadow: "0 20px 40px rgba(0,0,0,0.3)",
            position: "relative",
            overflow: "visible",
          },
        }}
        BackdropProps={{
          sx: {
            backgroundColor: "rgba(0,0,0,0.7)",
            backdropFilter: "blur(4px)",
          },
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: -30,
            left: "50%",
            transform: "translateX(-50%)",
            width: 60,
            height: 60,
            borderRadius: "50%",
            background: "linear-gradient(45deg, #2196F3, #1976D2)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 8px 20px rgba(33, 150, 243, 0.4)",
            animation: "bounce 0.6s ease-out",
            "&::after": {
              content: '"✓"',
              fontSize: "28px",
              color: "white",
              fontWeight: "bold",
            },
          }}
        />

        <DialogTitle
          sx={{
            textAlign: "center",
            pt: 5,
            pb: 2,
            fontSize: "1.5rem",
            fontWeight: "bold",
            background: "linear-gradient(45deg, #333333, #666666)",
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            color: "transparent",
          }}
        >
          Order Submitted Successfully!
        </DialogTitle>

        <DialogContent
          sx={{
            textAlign: "center",
            py: 3,
            px: 4,
          }}
        >
          <Typography
            variant="h6"
            gutterBottom
            sx={{
              color: "#666666",
              fontWeight: 500,
              mb: 2,
            }}
          >
            Your Order Number is:
          </Typography>

          <Box
            sx={{
              background: "rgba(33, 150, 243, 0.1)",
              borderRadius: 2,
              p: 3,
              mb: 3,
              backdropFilter: "blur(10px)",
              border: "1px solid rgba(33, 150, 243, 0.2)",
              boxShadow: "inset 0 2px 10px rgba(33, 150, 243, 0.1)",
            }}
          >
            <Typography
              variant="h4"
              sx={{
                fontWeight: "bold",
                color: "#2196F3",
                letterSpacing: "0.1em",
                textShadow: "0 2px 4px rgba(0,0,0,0.3)",
                fontFamily: "monospace",
              }}
            >
              {submittedorderNumber}
            </Typography>
          </Box>

          <Typography
            variant="body2"
            sx={{
              color: "#888888",
              fontStyle: "italic",
            }}
          >
            Keep this number for your records
          </Typography>
        </DialogContent>

        <DialogActions
          sx={{
            justifyContent: "center",
            pb: 3,
            px: 4,
            gap: 2,
          }}
        >
          <Button
            variant="outlined"
            onClick={handleCopy}
            startIcon={<ContentCopyIcon />}
            sx={{
              borderColor: "rgba(33, 150, 243, 0.5)",
              color: "#2196F3",
              backdropFilter: "blur(10px)",
              background: "rgba(33, 150, 243, 0.1)",
              "&:hover": {
                borderColor: "#2196F3",
                background: "rgba(33, 150, 243, 0.2)",
                transform: "translateY(-2px)",
                boxShadow: "0 4px 12px rgba(33, 150, 243, 0.3)",
              },
              transition: "all 0.3s ease",
              borderRadius: 2,
              px: 3,
            }}
          >
            Copy
          </Button>

          <Button
            variant="outlined"
            onClick={handleDownloadInvoice}
            startIcon={<FaFilePdf />}
            sx={{
              borderColor: "rgba(233, 30, 99, 0.5)",
              color: "#E91E63",
              backdropFilter: "blur(10px)",
              background: "rgba(233, 30, 99, 0.1)",
              "&:hover": {
                borderColor: "#E91E63",
                background: "rgba(233, 30, 99, 0.2)",
                transform: "translateY(-2px)",
                boxShadow: "0 4px 12px rgba(233, 30, 99, 0.3)",
              },
              transition: "all 0.3s ease",
              borderRadius: 2,
              px: 3,
            }}
          >
            Download Invoice
          </Button>

          <Button
            variant="contained"
            onClick={onClose}
            sx={{
              background: "linear-gradient(45deg, #2196F3, #1976D2)",
              color: "white",
              boxShadow: "0 4px 15px rgba(33, 150, 243, 0.4)",
              "&:hover": {
                background: "linear-gradient(45deg, #1976D2, #1565C0)",
                transform: "translateY(-2px)",
                boxShadow: "0 6px 20px rgba(33, 150, 243, 0.6)",
              },
              transition: "all 0.3s ease",
              borderRadius: 2,
              px: 3,
              fontWeight: "bold",
            }}
          >
            Close
          </Button>
        </DialogActions>

        <style jsx>{`
          @keyframes bounce {
            0%,
            20%,
            53%,
            80%,
            100% {
              transform: translateX(-50%) translateY(0);
            }
            40%,
            43% {
              transform: translateX(-50%) translateY(-15px);
            }
            70% {
              transform: translateX(-50%) translateY(-7px);
            }
            90% {
              transform: translateX(-50%) translateY(-2px);
            }
          }
        `}</style>
      </Dialog>
    );
  };

  useEffect(() => {
    fetchCustomerData();
  }, []);

  const handleCloseCreateModal = () => {
    setCreateDialogOpen(false);
    setEditingOrder(null);
  };

  useEffect(() => {
    const searchTerm = filters.search?.toLowerCase() || "";
    let filteredData = allCustomerData;
    if (searchTerm) {
      filteredData = allCustomerData.filter(
        (item) =>
          item.accountName?.toLowerCase().includes(searchTerm) ||
          item.accountType?.toLowerCase().includes(searchTerm) ||
          String(item.orderNumber || "")
            ?.toLowerCase()
            .includes(searchTerm) || // Convert to string
          item.orderDate?.toLowerCase().includes(searchTerm) ||
          item.orderStatus?.toLowerCase().includes(searchTerm) ||
          item.orderDescription?.toLowerCase().includes(searchTerm) ||
          item.simType?.toLowerCase().includes(searchTerm) ||
          String(item.numberOfSims || "")
            ?.toLowerCase()
            .includes(searchTerm) // Convert to string
      );
    }
    setTotalRows(filteredData.length);
    const startIndex = filters.pageNo * filters.pageSize;
    const endIndex = startIndex + filters.pageSize;
    const paginatedData = filteredData.slice(startIndex, endIndex);
    setCustomerList(paginatedData);
  }, [filters.search, filters.pageNo, filters.pageSize, allCustomerData]);

  return (
    <>
      <div className={styles.headingContainer} style={{ marginTop: "20px" }}>
        <Heading
          data={customerList}
          showSearch={true}
          arrowRedirection={false}
          showToFromDate={false}
          buttonArray={buttonArray}
          setSearchTerm={setSearchTerm}
          searchTerm={searchTerm}
          handleButtonAction={handleButtonAction}
          setFilters={setFilters}
          filters={filters}
        />

        <Grid
          container
          alignItems="center"
          spacing={2}
          sx={{ paddingRight: "63px", paddingBottom: "11px" }}
        >
          <Grid
            item
            md={0.4}
            sx={{ display: "flex", alignItems: "center" }}
          ></Grid>
          <Grid
            item
            md={2.6}
            sx={{ display: "flex", alignItems: "center" }}
          ></Grid>
          <Grid
            item
            md={9}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "baseline",
            }}
          ></Grid>
        </Grid>
      </div>
      <div className={styles.container}>
        <CommonTable
          showsort={true}
          setData={setCustomerList}
          columns={columns}
          data={customerList}
          tableCss={tableCss}
          filters={filters}
          totalRows={totalRows}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
      </div>
      {createDialogOpen && (
        <CreateOrderModal
          open={createDialogOpen}
          onClose={handleCloseCreateModal}
          editingOrder={editingOrder}
          allCustomerData={allCustomerData}
          fetchCustomerData={fetchCustomerData}
          setSubmittedorderNumber={setSubmittedorderNumber}
        />
      )}

      <SubmittedOrderConfirmationModal
        open={!!submittedorderNumber}
        orderNumber={submittedorderNumber}
        onClose={() => setSubmittedorderNumber(null)}
      />
      {csvData && generateCSV(csvData, "customer_data.csv")}
    </>
  );
};

export default CreateOrder;
